export type TrackingEvent = "PageView" | "ViewContent" | "Search" | "AddToCart" | "InitiateCheckout" | "AddPaymentInfo" | "Purchase" | "Lead" | "Subscribe" | "Contact";

export function track(event: TrackingEvent, payload: Record<string, unknown> = {}) {
  window.dispatchEvent(new CustomEvent("commerce:track", { detail: { event, payload } }));
  const w = window as unknown as { fbq?: (...args: unknown[]) => void; ttq?: { track: (...args: unknown[]) => void }; dataLayer?: unknown[] };
  w.fbq?.("track", event, payload);
  w.ttq?.track(event, payload);
  w.dataLayer?.push({ event, ...payload });
}

export function captureUtm() {
  const params = new URLSearchParams(location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const data = Object.fromEntries(keys.map((key) => [key, params.get(key)]).filter(([, value]) => value));
  if (Object.keys(data).length) localStorage.setItem("commerce_utm", JSON.stringify({ ...data, landing_page: location.href, referrer: document.referrer }));
}
